import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
  makeApiActionCreator,
} from '@actions/utils';
import * as api from '../api/stream';

const namespace = 'STREAM';

export const LOADS_FETCH = createRequestTypes(`${namespace}/LOADS_FETCH`);

export const fetchLoadStreams = makeApiActionCreator(
  api.fetchLoadStreams,
  LOADS_FETCH[START],
  LOADS_FETCH[SUCCESS],
  LOADS_FETCH[ERROR],
);

export const PROVIDERS_FETCH = createRequestTypes(
  `${namespace}/PROVIDERS_FETCH`,
);

export const fetchProviders = makeApiActionCreator(
  api.fetchProviders,
  PROVIDERS_FETCH[START],
  PROVIDERS_FETCH[SUCCESS],
  PROVIDERS_FETCH[ERROR],
);

export const CREATE_CREDENTIALS = createRequestTypes(
  `${namespace}/CREATE_CREDENTIALS`,
);

export const createCredentialsLoadStreams = makeApiActionCreator(
  api.createCredentialsLoadStreams,
  CREATE_CREDENTIALS[START],
  CREATE_CREDENTIALS[SUCCESS],
  CREATE_CREDENTIALS[ERROR],
);

export const DELETE_CREDENTIALS = createRequestTypes(
  `${namespace}/DELETE_CREDENTIALS`,
);

export const deleteCredentialsLoadStreams = makeApiActionCreator(
  api.deleteCredentialsLoadStreams,
  DELETE_CREDENTIALS[START],
  DELETE_CREDENTIALS[SUCCESS],
  DELETE_CREDENTIALS[ERROR],
);
